//  /////////////// COPYRIGHT © 2025/2026 IROÏD/DSTRKT™ FOR TIXFORGIGS
//  ////////////////////////////////////////////// ALL RIGHTS RESERVED
//  /////// LICENSED UNDER THE IROÏD LICENSE VERSION 1.0 [THE LICENSE]
//  /////// DO NOT USE THIS FILE EXCEPT IN COMPLIANCE WITH THE LICENSE
//
//  TixforGigs™ Unified API
//
//  VERSION: 4.6
//  PACKAGE: 4.6.297-SNAPSHOT
//  CONTACT: developer@tixforgigs.com
//  CREATED: 2026-02-26T01:20:10.489677Z
//
//  /////////////////////////////////////// AUTOGENERATED. DO NOT EDIT

@file:Suppress(
  "ArrayInDataClass",
  "EnumEntryName",
  "RemoveRedundantQualifierName",
  "UnusedImport"
)

package com.tixforgigs.apax.models

import com.tixforgigs.apax.models.PersonalizationField

        import kotlinx.serialization.*
  import kotlinx.serialization.descriptors.*
  import kotlinx.serialization.encoding.*

/**
* The event model
* 
* @param cartItemId The cart item id
* @param id The id
* @param personalizationFields The fields
*/
@Serializable

data class PersonalizationData (


      /* The cart item id */
    @SerialName(value = "cartItemId") @Required val cartItemId: kotlin.uuid.Uuid,


      /* The id */
    @SerialName(value = "id") @Required val id: kotlin.Int,


      /* The fields */
    @SerialName(value = "personalizationFields") @Required val personalizationFields: kotlin.collections.List<PersonalizationField>


) {




  }

